import React from "react";
import { Navigate, useParams } from "react-router-dom";
import OnePieceSetTemplatePage from "./OnePieceSetTemplatePage";

// Expected route: /one-piece/sets/:setSlug
export default function OnePieceSetRoutePage() {
  const { setSlug } = useParams();
  const normalizedSlug = String(setSlug || "").trim().toLowerCase();

  if (normalizedSlug === "eb04" || normalizedSlug === "op15-eb04") {
    return <Navigate to="/one-piece/sets/op15" replace />;
  }

  return <OnePieceSetTemplatePage setSlug={setSlug} />;
}
